export default {
  product: undefined,
  products: [],
};
